import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import "./ourservices.css";
import img from "../../assets/ourservices/Project planning & scheduling.jpeg";
// import img1 from "../../assets/ourservices/Project planning & scheduling.jpeg";
import img1 from "../../assets/ourservices/Budgeting & cost control.jpeg";
import img2 from "../../assets/ourservices/Labour and workforce management.jpeg";
import img3 from "../../assets/banner/const.jpg";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faToolbox, faShippingFast, faBuilding, faHammer, faIndustry, faDraftingCompass } from '@fortawesome/free-solid-svg-icons';

function Ourservices() {
  const navigate = useNavigate();
  const [visibleImages, setVisibleImages] = useState(3); // Show 3 images initially

  const allServices = [
      { image: img, title: "Project Planning & Scheduling", icon: faToolbox },
      { image: img1, title: "Budgeting & cost control", icon: faShippingFast },
      { image: img2, title: "Labour and workforce management", icon: faBuilding },
      { image: img3, title: "Construction Management", icon: faHammer },
      // { image: img4, title: "Industrial Development", icon: faIndustry },
      // { image: img5, title: "Architectural Design", icon: faDraftingCompass }
  ];

  const handleShowMore = () => {
    setVisibleImages((prev) => Math.min(prev + 3, allServices.length));
  };

  return (
    <>
      <section id="service_section" className="padding ptb-xs-40">
        <div className="container">
          <div className="row text-center mb-30">
            <div className="col-sm-12">
              <div className="sec_hedding">
                <h2><span>Our</span> Services</h2>
                <div className='underline-service'></div>
                <span className="b-line"></span>
              </div>
            </div>
          </div>

          <div className="row">
            {allServices.slice(0, visibleImages).map((service, index) => (
              <div className="col-xl-4 col-lg-3 col-md-6 mb-xs-30 margin_bott" key={index} 
              onClick={() => {
                window.scrollTo(0,0)
              navigate("/all-service")}}>
                <div className="maine_box">
                  <div className="items_picher">
                    <img src={service.image} alt={service.title} />
                  </div>

                  <div className="box_detail">
                    <div className="use_detail">
                      <div className="event_detail">
                        <FontAwesomeIcon icon={service.icon} />
                      </div>
                    </div>
                    <div className="datail_show">
                      <h3>{service.title}</h3>
                      {/* <button onClick={() => navigate(`/service/${index + 1}`)}>Read More</button> */}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* <div className="text-center mt-4">
            {visibleImages < allServices.length ? (
              <button className="btn btn-primary" onClick={handleShowMore}>Load More</button>
            ) : (
              <button className="btn btn-secondary" onClick={() => navigate("/all-service")}>View All Services</button>
            )}
          </div> */}
        </div>
      </section>
    </>
  );
}

export default Ourservices;
